// import authModule from '../auth/auth-module'
import authStore from "../auth/auth-store";
import contactStore from "./contactStore";
import { vuexfireMutations } from "vuexfire";
// const store = new Vuex.Store({ modules: authStore(),mutations: {...vuexfireMutations}, });
import Vuex from "vuex";
import Vue from "vue";
Vue.use(Vuex);
// const store = new Vuex.Store({ modules: authStore });
// const modules = [authModule]
// const buildStores = () => {
//   const output = {};

//   Object.keys(modules)
//     .filter((key) => !!modules[key].store)
//     .forEach((key) => {
//       output[key] = modules[key].store;
//     });

//   return output;
// };
const stores = [authStore, contactStore];
let store = null;

const storeAsync = () => {
  if (!store) {
    store = new Vuex.Store({
      modules: stores,
      mutations: { ...vuexfireMutations },
    });
  }

  return store;
};

export default storeAsync;
